import { render, staticRenderFns } from "./ItemTypeClickInspector.vue?vue&type=template&id=477ee645&scoped=true"
import script from "./ItemTypeClickInspector.vue?vue&type=script&lang=ts"
export * from "./ItemTypeClickInspector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ee645",
  null
  
)

export default component.exports